/* [R13] 16 Oct 2026 — ten moves, built for the preview theme on Abhi's "build all 10 on the preview".
   1 fly to bag (MotionPath) · 2 Diwali box finder (Flip) · 3 fill your box by hand (Draggable+Inertia)
   4 cut-off countdown (SplitText + odometer) · 5 gold store thread (DrawSVG) · 6 doors that open (21st.dev Hover Expand)
   7 photo lens (21st.dev Lens) · 8 swipe to choose (21st.dev Swipe Deck) · 9 What's inside sheet (shadcn Drawer)
   10 sweet name cards (shadcn Hover Card).
   Everything enhances markup that is already on the page and does nothing if that markup is missing.
   ?r13=off (remembered for the visit) switches the lot off; ?r13=on brings it back. */
(function () {
  'use strict';
  try {
    var qs = new URLSearchParams(location.search).get('r13');
    if (qs) sessionStorage.setItem('pd-r13', qs);
    if (sessionStorage.getItem('pd-r13') === 'off') return;
  } catch (_) {}
  if (!window.gsap) return;
  var G = window.gsap;
  ['ScrollTrigger', 'Flip', 'Draggable', 'InertiaPlugin', 'MotionPathPlugin', 'DrawSVGPlugin', 'SplitText'].forEach(function (n) { if (window[n]) G.registerPlugin(window[n]); });
  document.documentElement.classList.add('pd13');

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var visible = function (el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden'; };
  var isDiwaliPage = /\/collections\/diwali\/?$/.test(location.pathname);
  var isHome = location.pathname === '/';
  var isProduct = document.body.classList.contains('template-product');
  // theme asset folder (same folder as pd-r2.css), for the sweet photos already in the theme
  var assetBase = (function () { var l = $('link[href*="/assets/pd-r2.css"]'); return l ? l.href.split('/assets/')[0] + '/assets/' : null; })();
  // other pd-* scripts build parts of the page (e.g. the Create Your Own box) on DOMContentLoaded, after this file runs,
  // so each feature starts a tick after that, and waits up to 4 s for the markup it enhances
  var queue = [];
  function safe(name, fn) { queue.push([name, fn]); }
  function runAll() { queue.forEach(function (q) { try { q[1](); } catch (e) { if (window.console) console.warn('[pd-r13] ' + q[0], e); } }); }
  // after the Create Your Own picker is opened and shut out of sight, make sure its page lock is gone
  function unlockCyo() { setTimeout(function () { var s = document.querySelector('dialog.pd-cyo-sheet'); if (!s || !s.open) document.documentElement.classList.remove('pd-cyo-lock'); }, 450); }
  function when(test, fn) { var t0 = Date.now(); (function go() { var v = test(); if (v) fn(v); else if (Date.now() - t0 < 4000) setTimeout(go, 150); })(); }

  /* ---------- shared sweet data (ingredients copied from the product pages' What's inside lists) ---------- */
  var SWEETS = {
    'kaju katli': ['Kaju Katli', 'Cashew, sugar, silver leaf', 'Tree nuts, Cashew', 'kaju-katli'],
    'pista burfi': ['Pista Burfi', 'Khoya, ghee, sugar, pistachio', 'Dairy, Tree nuts, Pistachio', 'pista-burfi'],
    'khoya burfi': ['Khoya Burfi', 'Slow-reduced khoya & milk, sugar, ghee, cardamom', 'Dairy', 'khoya-burfi'],
    'motichoor ladoo': ['Motichoor Ladoo', 'Besan boondi, ghee, saffron, sugar syrup', 'Dairy, Chickpea', 'orange-motichoor-ladoo'],
    'kesar motichoor ladoo': ['Kesar Motichoor Ladoo', 'Besan boondi, ghee, saffron, sugar, pistachio', 'Dairy, Chickpea, Tree nuts, Pistachio', 'orange-motichoor-ladoo'],
    'milk cake': ['Milk Cake', 'Slow-reduced milk solids, sugar, ghee', 'Dairy', 'milk-cake'],
    'dhoda burfi': ['Dhoda Burfi', 'Slow-reduced milk solids, sugar, wheat, ghee, cashew', 'Dairy, Tree nuts, Almond, Wheat (Gluten)', 'dhoda'],
    'dhoda': ['Dhoda', 'Slow-reduced milk solids, sugar, wheat, ghee, cashew', 'Dairy, Tree nuts, Almond, Wheat (Gluten)', 'dhoda'],
    'dhodha': ['Dhoda', 'Slow-reduced milk solids, sugar, wheat, ghee, cashew', 'Dairy, Tree nuts, Almond, Wheat (Gluten)', 'dhoda'],
    'besan ladoo': ['Besan Ladoo', 'Roasted besan, ghee, sugar, cardamom, mixed nuts', 'Dairy, Chickpea', 'besan-ladoo'],
    'besan burfi': ['Besan Burfi', 'Roasted besan, ghee, sugar, cardamom', 'Dairy, Chickpea', 'besan-burfi'],
    'gulab jamun': ['Gulab Jamun', 'Fresh chenna, khoya, ghee, rose-cardamom syrup', 'Dairy, Flour (Gluten)', 'gulab-jamun'],
    'rasgulla': ['Rasgulla', 'Fresh chenna, light syrup', 'Dairy, Flour (Gluten)', 'rasgulla'],
    'chum chum': ['Chum Chum', 'Chenna, cream, sugar, cardamom', 'Dairy, Flour (Gluten)', 'chum-chum'],
    'mathura peda': ['Mathura Peda', 'Slow-roasted khoya & milk, ghee, sugar, cardamom', 'Dairy', 'mathura-peda'],
    'kesar peda': ['Kesar Peda', 'Milk, khoya, ghee, sugar, saffron', 'Dairy', 'kesar-peda'],
    'almond burfi': ['Almond Burfi', 'Milk, khoya, ghee, sugar, almond', 'Dairy, Tree nuts, Almond', 'almond-burfi'],
    'plain burfi': ['Plain Burfi', 'Milk, khoya, ghee, sugar, cardamom', 'Dairy', 'plain-burfi'],
    'chocolate burfi': ['Chocolate Burfi', 'Milk, khoya, ghee, sugar, cocoa', 'Dairy', 'chocolate-burfi'],
    'mango burfi': ['Mango Burfi', 'Milk, khoya, ghee, sugar, fresh mango', 'Dairy', 'mango-burfi'],
    'kesar pista burfi': ['Kesar Pista Burfi', 'Milk, khoya, ghee, sugar, saffron, shaved pistachio', 'Dairy, Tree nuts, Pistachio', 'kesar-pista-burfi'],
    'pista coco burfi': ['Pista Coconut Burfi', 'Milk, khoya, ghee, sugar, pistachio, coconut', 'Dairy, Coconut, Tree nuts, Pistachio', 'pista-coconut-burfi'],
    'rose coco burfi': ['Rose Coconut Burfi', 'Milk, khoya, ghee, sugar, rose, coconut', 'Dairy, Coconut', 'rose-coconut-burfi'],
    'roasted dry fruit burfi': ['Roasted Dry Fruit Burfi', 'Cashew, mixed nuts, saffron, sugar, silver foil', 'Tree nuts, Cashew', 'roasted-dry-fruit-burfi'],
    'kaju pista roll': ['Kaju Pista Roll', 'Cashew, sugar, pistachio, silver leaf', 'Tree nuts, Cashew, Pistachio', 'kaju-pista-roll'],
    'kaju roll': ['Kaju Roll', 'Cashew, sugar, pistachio, silver leaf', 'Tree nuts, Cashew', 'kaju-pista-roll'],
    'kaju samosa': ['Kaju Samosa', 'Cashew, mixed dry fruits, sugar, ghee', 'Dairy, Tree nuts, Cashew', 'kaju-samosa'],
    'kaju jalebi': ['Kaju Jalebi', 'Cashew, sugar, silver leaf', 'Tree nuts, Cashew', 'kaju-jalebi'],
    'jodhpuri ladoo': ['Jodhpuri Ladoo', 'Besan, ghee, cashew, cardamom', 'Dairy, Chickpea, Tree nuts', 'jodhpuri-ladoo'],
    'rose badaam ladoo': ['Rose Badaam Ladoo', 'Almond, rose petals, sugar', 'Dairy, Tree nuts, Almond', 'rose-badaam-ladoo'],
    'gond ladoo': ['Gond Ladoo', 'Edible gum, wheat, ghee, dry fruits, sugar', 'Dairy, Tree nuts, Wheat (Gluten)', ''],
    'danedar burfi': ['Danedar Burfi', 'Chickpea, flour, sugar, ghee, almond', 'Dairy, Flour (Gluten), Tree nuts', ''],
    'sangam burfi': ['Sangam Burfi', 'White gourd, semolina, cashew, pistachio, ghee, sugar', 'Wheat (Gluten), Tree nuts, Dairy', ''],
    'channa burfi': ['Channa Burfi', 'Slow-roasted black channa, ghee, sugar', 'Dairy, Chickpea', ''],
    'roasted salted cashew': ['Roasted Salted Cashew', 'Roasted cashew kernels, salt', 'Tree nuts, Cashew', ''],
    'salted cashew': ['Salted Cashew', 'Roasted cashew kernels, salt', 'Tree nuts, Cashew', ''],
    'salted almonds': ['Salted Almonds', 'Roasted almond kernels, salt', 'Tree nuts, Almond', ''],
    'roasted salted pistachio': ['Roasted Salted Pistachio', 'Roasted pistachio in shell, salt', 'Tree nuts', '']
  };
  var sweetPhoto = function (slug) { return slug && assetBase ? assetBase + 'pd-cyo-pc-' + slug + '.jpg' : ''; };

  /* =========================================================================================
     1 · The box flies into the bag (MotionPath)
     ========================================================================================= */
  safe('1-fly', function () {
    // The theme opens the bag panel (#site-cart-sidebar) after every add, so the photo lifts off, waits for the panel,
    // then lands on this box's new line in it. If the panel doesn't show in time it lands on the bag button instead.
    function bagButton() {
      var c = $$('[data-js-sidebar-handle][aria-controls="site-cart-sidebar"]').filter(function (e) { return visible(e) && e.getBoundingClientRect().top < innerHeight && e.getBoundingClientRect().bottom > 0; });
      return c[0] || null;
    }
    function sourceImg(btn) {
      var card = btn.closest('.product-item');
      if (card) return $('.product-item__image-figure--primary img', card) || $('img', card);
      if (isProduct) return $('.product-gallery .product-gallery-item img') || $('.product-gallery-item img');
      return null;
    }
    function handleOf(btn) {
      var card = btn.closest('.product-item'), a = card && $('a[href*="/products/"]', card);
      var h = a ? a.getAttribute('href') : location.pathname;
      var m = String(h).match(/\/products\/([^\/?#]+)/); return m ? m[1] : null;
    }
    function lineIn(handle) {
      var sb = document.getElementById('site-cart-sidebar');
      if (!sb || sb.getAttribute('aria-hidden') === 'true' || getComputedStyle(sb).display === 'none') return null;
      var a = handle && $('.cart-item a[href*="/products/' + handle + '"]', sb);
      var img = a && $('img', a); if (!img) return null;
      var r = img.getBoundingClientRect();
      return r.width > 0 && r.left < innerWidth && r.right > 0 ? { img: img, line: a.closest('.cart-item') } : null;
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-js-product-add-to-cart], button[name="add"]');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var img = sourceImg(btn); if (!img || !visible(img)) return;
      var handle = handleOf(btn), a = img.getBoundingClientRect(), S = 64;
      var sx = a.left + a.width / 2 - S / 2, sy = a.top + a.height / 2 - S / 2;
      if (reduce) return;
      var f = document.createElement('img');
      f.className = 'pd13-flyer'; f.alt = ''; f.src = img.currentSrc || img.src;
      document.body.appendChild(f);
      G.set(f, { x: sx, y: sy, scale: 1.5, opacity: 0 });
      // lift, then float gently while the bag panel opens
      G.to(f, { opacity: 1, scale: 1.1, y: sy - 26, duration: .3, ease: 'power2.out' });
      var bob = G.to(f, { y: sy - 34, duration: .5, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: .3 });
      var t0 = Date.now();
      (function look() {
        var hit = lineIn(handle);
        if (!hit && Date.now() - t0 < 4000) { setTimeout(look, 60); return; }
        // give the panel's slide-in a moment to settle, then read where the line really is
        setTimeout(function () {
          hit = lineIn(handle) || hit;
          bob.kill();
          var cx = G.getProperty(f, 'x'), cy = G.getProperty(f, 'y');
          var tr = hit ? hit.img.getBoundingClientRect() : (bagButton() || { getBoundingClientRect: function () { return { left: innerWidth - 56, top: 12, width: 40, height: 40 }; } }).getBoundingClientRect();
          var ex = tr.left + tr.width / 2 - S / 2, ey = tr.top + tr.height / 2 - S / 2, endScale = hit ? Math.max(.4, tr.width / S) : .3;
          G.timeline({ onComplete: function () {
              f.remove();
              if (hit) G.fromTo(hit.line, { backgroundColor: 'rgba(205,164,94,.28)' }, { backgroundColor: 'rgba(205,164,94,0)', duration: 1.1, ease: 'power2.out', clearProps: 'backgroundColor' });
              else { var bb = bagButton(); if (bb) G.fromTo(bb, { scale: 1.18 }, { scale: 1, duration: .55, ease: 'expo.out', clearProps: 'transform' }); }
            } })
            .to(f, { duration: .7, ease: 'power3.inOut', scale: endScale, borderRadius: hit ? '6px' : '50%',
              motionPath: { path: [{ x: cx, y: cy }, { x: (cx + ex) / 2, y: Math.min(cy, ey) - 90 }, { x: ex, y: ey }], curviness: 1.3 } })
            .to(f, { opacity: 0, duration: .18 }, '>-.06');
        }, hit ? 260 : 0);
      })();
    }, true);
  });

  /* =========================================================================================
     2 · Diwali box finder (Flip)  +  8 · Swipe to choose (Draggable)  — Diwali collection page
     ========================================================================================= */
  safe('2-finder', function () {
    if (!isDiwaliPage) return;
    // wait for the phone "size shelves" test (pd-r4) to decide first: it marks <html data-pd-shelf> a moment after load
    var t0 = Date.now();
    (function go() {
      if (document.documentElement.hasAttribute('data-pd-shelf') || Date.now() - t0 > 1500 || matchMedia('(min-width: 768px)').matches) finder();
      else setTimeout(go, 100);
    })();
  });
  function finder() {
    var grid = $('#main-collection-product-grid');
    if (!grid || !window.Flip) return;
    // phones in the "size shelves" test (pd-r4, html[data-pd-shelf=on]) already sort boxes by size: no chips there, only Help me choose
    var shelf = document.documentElement.getAttribute('data-pd-shelf') === 'on';
    // move 2 (the size chips) was dropped by Abhi on 16 Oct; only move 8's Help me choose button stays. Set to false to bring the chips back.
    var noChips = true;
    var cards = shelf ? $$('main .product-item') : $$('.product-item', grid);
    if (cards.length < 4) return;
    var kindOf = function (c) {
      var s = ($('.pd-card-tag__size', c) || {}).textContent || '';
      s = s.replace(/\s+/g, ' ').trim();
      if (/^1(\.\d)?\s*kg/.test(s)) return 'large';
      if (/500\s*g/.test(s)) return 'small';
      if (/250\s*g/.test(s)) return 'xs';
      return 'extras';
    };
    cards.forEach(function (c) { c.setAttribute('data-pd13-k', kindOf(c)); });
    var count = function (k) { return cards.filter(function (c) { return c.getAttribute('data-pd13-k') === k; }).length; };
    var CH = [['all', 'All'], ['large', 'Family table · 1 kg'], ['small', 'Neighbours · 500 g'], ['xs', 'The long list · 250 g'], ['extras', 'Sweets & extras']];
    var bar = document.createElement('div');
    bar.className = 'pd13-finder'; bar.setAttribute('role', 'group'); bar.setAttribute('aria-label', 'Who is it for');
    bar.innerHTML = (shelf || noChips ? '' : '<span class="pd13-finder__l">Who is it for?</span>') +
      (shelf || noChips ? [] : CH.filter(function (c) { return c[0] === 'all' || count(c[0]); })).map(function (c) { return '<button type="button" class="pd13-chip" data-k="' + c[0] + '" aria-pressed="' + (c[0] === 'all') + '">' + c[1] + '</button>'; }).join('') +
      '<button type="button" class="pd13-help">Help me choose</button>';
    var anchor = shelf ? ($('[class*="shelf"]') || grid) : grid;
    anchor.parentNode.insertBefore(bar, anchor);

    function show(k, instant) {
      var state = Flip.getState(Array.prototype.slice.call(grid.children));
      $$('.pd13-chip', bar).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-k') === k)); });
      cards.forEach(function (c) { c.classList.toggle('pd13-hide', k !== 'all' && c.getAttribute('data-pd13-k') !== k); });
      // the bands placed inside the grid (ready-made sets, review, "Sweets, snacks and extras") step aside while a filter is on
      Array.prototype.slice.call(grid.children).forEach(function (el) { if (!el.classList.contains('product-item')) el.classList.toggle('pd13-hide', k !== 'all'); });
      try { window.dispatchEvent(new Event('resize')); } catch (_) {}
      if (instant || reduce) return;
      Flip.from(state, { duration: .7, ease: 'power3.inOut', absolute: true, stagger: .02, nested: true,
        onEnter: function (els) { return G.fromTo(els, { opacity: 0, scale: .92 }, { opacity: 1, scale: 1, duration: .5, delay: .12 }); },
        onLeave: function (els) { return G.to(els, { opacity: 0, scale: .92, duration: .3 }); } });
    }
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('.pd13-chip'); if (b) show(b.getAttribute('data-k'));
    });
    // the hero size chips filter the grid in place instead of reloading the page (not in the shelves test: there they jump to a shelf)
    if (!shelf && !noChips) $$('.hv__chips a.chip').forEach(function (a) {
      var h = a.getAttribute('href') || '';
      var k = /gte=30/.test(h) ? 'large' : /gte=20/.test(h) ? 'small' : /lte=15/.test(h) ? 'xs' : null;
      if (!k) return;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        bar.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        setTimeout(function () { show(k); }, reduce ? 0 : 450);
      });
    });

    /* ---- 8 · Swipe to choose ---- */
    var boxes = cards.filter(function (c) { return c.getAttribute('data-pd13-k') !== 'extras'; }).map(function (c) {
      var a = $('a.product-item__title', c), img = $('.product-item__image-figure--primary img', c);
      var src = img ? (img.currentSrc || img.src || '').replace(/([?&])width=\d+/, '$1width=720') : '';
      var price = (($('.product-price', c) || {}).textContent || '').replace(/Regular price/i, '').replace(/\s+/g, '').trim();
      var size = (($('.pd-card-tag__size', c) || {}).textContent || '').trim();
      var inside = (($('.pd-card-contents', c) || {}).textContent || '').replace(/What's inside:\s*/i, '').replace(/Peek inside/i, '').trim();
      return { n: a ? a.textContent.trim() : '', href: a ? a.getAttribute('href') : '#', img: src, d: [price, size].filter(Boolean).join(' · '), inside: inside };
    }).filter(function (b, i, arr) { return b.n && b.img && arr.findIndex(function (x) { return x.n === b.n; }) === i; });
    // ten cards, sizes taken in turn (large, small, extra small...) so the deck is quick and varied
    (function () {
      var by = { large: [], small: [], xs: [] };
      cards.forEach(function (c) { var k = c.getAttribute('data-pd13-k'); var a = $('a.product-item__title', c); if (by[k] && a) by[k].push(a.textContent.trim()); });
      var order = [], i = 0;
      while (order.length < 10 && (by.large[i] || by.small[i] || by.xs[i])) { ['large', 'small', 'xs'].forEach(function (k) { if (by[k][i] && order.length < 10) order.push(by[k][i]); }); i++; }
      boxes = order.map(function (n) { return boxes.filter(function (b) { return b.n === n; })[0]; }).filter(Boolean);
    })();
    if (!boxes.length || !window.Draggable) { $('.pd13-help', bar).remove(); return; }

    var dlg = document.createElement('dialog');
    dlg.className = 'pd13-dlg'; dlg.setAttribute('aria-label', 'Help me choose');
    dlg.innerHTML = '<div class="pd13-dlg__in"><div class="pd13-dlg__hd"><p class="pd13-dlg__t">Swipe to choose</p><button type="button" class="pd13-x" aria-label="Close">×</button></div>' +
      '<p class="pd13-dlg__s" style="margin:0;font-size:14px;color:var(--pd13-soft)">Right for boxes you like, left for ones you don\'t.</p>' +
      '<div class="pd13-deck" tabindex="0" aria-label="Boxes. Left arrow skips, right arrow keeps."></div>' +
      '<div class="pd13-ctl"><button type="button" data-a="skip">Skip</button><span></span><button type="button" class="pd13-k" data-a="keep">Keep</button></div>' +
      '<div class="pd13-sl" hidden></div></div>';
    document.body.appendChild(dlg);
    var deck = $('.pd13-deck', dlg), ctl = $('.pd13-ctl', dlg), left = $('.pd13-ctl span', dlg), sl = $('.pd13-sl', dlg);
    var idx = 0, kept = [], dc = [];
    function layout() {
      dc.forEach(function (c, i) {
        var depth = i - idx; if (depth < 0) return;
        c.style.zIndex = 50 - depth; c.hidden = depth > 2;
        G.to(c, { y: depth * 12, scale: 1 - depth * .045, duration: reduce ? 0 : .45, ease: 'power3.out' });
        var d = Draggable.get(c); if (d) { if (depth === 0) d.enable(); else d.disable(); }
      });
      left.textContent = (boxes.length - idx) + ' left';
    }
    function decide(keep) {
      var c = dc[idx]; if (!c) return;
      var dir = keep ? 1 : -1; if (keep) kept.push(boxes[idx]);
      var d = Draggable.get(c); if (d) d.disable();
      G.to($(keep ? '.pd13-stamp--k' : '.pd13-stamp--s', c), { opacity: 1, duration: .1 });
      G.to(c, { x: dir * 520, rotation: dir * 18, opacity: 0, duration: reduce ? 0 : .4, ease: 'power2.in', onComplete: function () { c.hidden = true; } });
      idx++; layout();
      if (idx >= boxes.length) finish();
    }
    function finish() {
      ctl.hidden = true; deck.hidden = true; sl.hidden = false;
      sl.innerHTML = '<p class="pd13-dlg__t" style="font-size:24px">' + (kept.length ? 'Your shortlist' : 'Nothing kept') + '</p>' +
        kept.map(function (b) { return '<a href="' + b.href + '"><img src="' + b.img + '" alt=""><span>' + b.n + '<br><em>' + b.d + '</em></span><span aria-hidden="true">→</span></a>'; }).join('') +
        '<button type="button" class="pd13-again">Start again</button>';
      if (!reduce) G.from($$('a', sl), { y: 16, opacity: 0, stagger: .06, duration: .45, ease: 'power3.out' });
    }
    function build() {
      deck.innerHTML = ''; idx = 0; kept = []; ctl.hidden = false; deck.hidden = false; sl.hidden = true;
      dc = boxes.map(function (b) {
        var c = document.createElement('div'); c.className = 'pd13-card'; c.setAttribute('aria-label', b.n + ', ' + b.d);
        c.innerHTML = '<img src="' + b.img + '" alt="" draggable="false"><div class="pd13-card__c"><span class="pd13-card__n">' + b.n + '</span><span class="pd13-card__d">' + b.d + (b.inside ? ' · ' + b.inside : '') + '</span></div><span class="pd13-stamp pd13-stamp--k">Keep</span><span class="pd13-stamp pd13-stamp--s">Skip</span>';
        deck.appendChild(c);
        Draggable.create(c, { type: 'x', minimumMovement: 4,
          onPress: function () { if (window.InertiaPlugin) InertiaPlugin.track(c, 'x'); },
          onDrag: function () {
            var t = Math.max(-1, Math.min(1, this.x / 110));
            G.set(c, { rotation: t * 10 });
            G.set($('.pd13-stamp--k', c), { opacity: Math.max(0, t) }); G.set($('.pd13-stamp--s', c), { opacity: Math.max(0, -t) });
          },
          onDragEnd: function () {
            var v = window.InertiaPlugin ? Math.abs(InertiaPlugin.getVelocity(c, 'x') || 0) : 0;
            if (Math.abs(this.x) > 110 || (v > 600 && Math.abs(this.x) > 40)) decide(this.x > 0);
            else { G.to(c, { x: 0, rotation: 0, duration: .5, ease: 'power3.out' }); G.to($$('.pd13-stamp', c), { opacity: 0, duration: .2 }); }
          } });
        return c;
      });
      layout();
    }
    $('.pd13-help', bar).addEventListener('click', function () { build(); dlg.showModal(); deck.focus(); });
    $('.pd13-x', dlg).addEventListener('click', function () { dlg.close(); });
    // close on a tap on the dimmed background only, never when a swipe ends out there
    var downOnBackdrop = false;
    dlg.addEventListener('pointerdown', function (e) { downOnBackdrop = e.target === dlg; });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg && downOnBackdrop) dlg.close();
      var a = e.target.closest('[data-a]'); if (a) decide(a.getAttribute('data-a') === 'keep');
      if (e.target.closest('.pd13-again')) build();
    });
    deck.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); decide(true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); decide(false); }
    });
  }

  /* =========================================================================================
     3 · Fill your box by hand (Draggable + Inertia) — Create Your Own product pages
     ========================================================================================= */
  // move 3 (sweet tray on Create Your Own) dropped by Abhi 16 Oct: showing 8 sweets made it look like the only choices. Set to true to bring it back.
  var CYO_TRAY = false;
  safe('3-cyo', function () { if (CYO_TRAY && window.Draggable) when(function () { return $('section.pd-cyo .pd-cyo__rows'); }, cyo); });
  function cyo() {
    var box = $('section.pd-cyo'); if (!box || $('.pd13-tray', box)) return;
    var sheet = $('dialog.pd-cyo-sheet');
    if (!sheet) {
      // the box builds its sweet list the first time it is opened: open and close it once, out of sight
      var op = $('.pd-cyo__open', box); if (!op) return;
      var y = scrollY, act = document.activeElement;
      document.documentElement.classList.add('pd13-silent');
      try { op.click(); sheet = $('dialog.pd-cyo-sheet'); var x0 = sheet && $('.pd-cyo-sheet__x', sheet); if (x0) x0.click(); }
      finally { setTimeout(function () { document.documentElement.classList.remove('pd13-silent'); }, 450); unlockCyo(); }
      if (scrollY !== y) scrollTo(0, y);
      if (act && act.focus) try { act.focus({ preventScroll: true }); } catch (_) {}
      if (!sheet) return;
    }
    var opts = $$('.pd-cyo__grid li > button[data-i]', sheet).slice(0, 8);
    if (!opts.length) return;
    var rowsEl = $('.pd-cyo__rows', box), msg = $('.pd-cyo__msg', box);
    var tray = document.createElement('div');
    tray.className = 'pd13-tray';
    tray.innerHTML = '<span class="pd13-tray__l">Most picked. Drag one into a row, or tap it.</span><div class="pd13-tray__row">' +
      opts.map(function (b) {
        var img = $('img', b), n = ($('.pd-cyo__t', b) || {}).textContent || '';
        return '<button type="button" class="pd13-sweet" data-i="' + b.getAttribute('data-i') + '" aria-label="Add ' + n + ' to the next empty row"><img src="' + (img ? img.getAttribute('src') : '') + '" alt="" draggable="false">' + n + '</button>';
      }).join('') + '</div>';
    rowsEl.parentNode.insertBefore(tray, rowsEl);

    var rows = function () { return $$('.pd-cyo__rows > li', box); };
    function say(t) { if (msg) msg.textContent = t; }
    // Uses the box's own picker so prices, premium rows and the cart line stay exactly as they are today.
    function pick(i, rowIdx) {
      var list = rows(); var li = list[rowIdx]; if (!li) return false;
      var html = document.documentElement;
      html.classList.add('pd13-silent');
      try {
        if (li.classList.contains('is-full')) { var rm = $('.pd-cyo__rm', li); if (rm) rm.click(); li = rows()[rowIdx]; }
        var p = $('.pd-cyo__pick', li); if (!p) return false;
        p.click();
        var opt = $('.pd-cyo__grid button[data-i="' + i + '"]', sheet); if (opt) opt.click();
        var x = $('.pd-cyo-sheet__x', sheet); if (x && sheet.open) x.click();
      } finally { setTimeout(function () { html.classList.remove('pd13-silent'); }, 450); unlockCyo(); }
      // the box always fills its first empty row, so find the row that now holds this sweet
      var nm = (($('.pd-cyo__grid button[data-i="' + i + '"] .pd-cyo__t', sheet) || {}).textContent || '').trim();
      var now = rows().filter(function (l) { return l.classList.contains('is-full') && nm && l.textContent.indexOf(nm) > -1; }).pop() || rows()[rowIdx];
      if (now && !reduce) G.fromTo(now, { scale: .96, backgroundColor: 'rgba(205,164,94,.22)' }, { scale: 1, backgroundColor: 'rgba(205,164,94,0)', duration: .7, ease: 'expo.out', clearProps: 'all' });
      return true;
    }
    var nextEmpty = function () { return rows().findIndex(function (l) { return l.classList.contains('is-empty'); }); };
    function full() { say('All four rows are full. Drag a sweet onto a row to swap it, or tap × on a row.'); if (!reduce) G.fromTo(rowsEl, { x: -6 }, { x: 0, duration: .5, ease: 'elastic.out(1,.35)' }); }

    $$('.pd13-sweet', tray).forEach(function (sw) {
      var i = sw.getAttribute('data-i'), offs = [], last = { x: 0, y: 0 };
      var near = function (x, y, r) { var best = null, bd = r; offs.forEach(function (o) { var d = Math.hypot(o.x - x, o.y - y); if (d < bd) { bd = d; best = o; } }); return best; };
      var d = Draggable.create(sw, { type: 'x,y', inertia: !!window.InertiaPlugin, zIndexBoost: true, minimumMovement: 6,
        onPress: function () {
          var r = sw.getBoundingClientRect(), cx = r.left + r.width / 2 - this.x, cy = r.top + r.height / 2 - this.y;
          offs = rows().map(function (l, k) { var q = l.getBoundingClientRect(); return { i: k, x: q.left + q.width / 2 - cx, y: q.top + q.height / 2 - cy, r: Math.max(q.height, 60) }; });
        },
        onDrag: function () { last = { x: this.x, y: this.y }; var n = near(this.x, this.y, 140); rows().forEach(function (l, k) { l.classList.toggle('pd13-hot', !!n && n.i === k); }); },
        snap: { points: function (p) { var n = near(p.x, p.y, 150) || near(d.x, d.y, 150) || near(last.x, last.y, 150); return n ? { x: n.x, y: n.y } : { x: 0, y: 0 }; } },
        onRelease: function () { rows().forEach(function (l) { l.classList.remove('pd13-hot'); }); },
        onThrowComplete: function () {
          var n = near(this.x, this.y, 10);
          G.set(sw, { x: 0, y: 0 });
          if (n) { pick(i, n.i); say(''); }
        },
        onClick: function () { tap(); }
      })[0];
      var lastTap = 0;
      function tap() { if (Date.now() - lastTap < 450) return; lastTap = Date.now(); var k = nextEmpty(); if (k < 0) { full(); return; } pick(i, k); }
      sw.addEventListener('click', function (e) { if (e.detail === 0) tap(); }); // keyboard
    });
  }

  /* =========================================================================================
     4 · Cut-off countdown (odometer + SplitText line reveal)
     ========================================================================================= */
  safe('4-countdown', function () {
    function odometer(el, n) {
      var digits = String(n).split('');
      el.textContent = '';
      var wrap = document.createElement('span'); wrap.className = 'pd13-odo'; wrap.setAttribute('aria-hidden', 'true');
      digits.forEach(function () {
        var dg = document.createElement('span'); dg.className = 'pd13-dg';
        dg.innerHTML = '<span>' + [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(function (x) { return '<span>' + x + '</span>'; }).join('') + '</span>';
        wrap.appendChild(dg);
      });
      el.appendChild(wrap);
      // each digit box takes the width of its own final digit, so "13" is spaced like the plain text it settles into
      $$('.pd13-dg', wrap).forEach(function (dg, k) {
        var m = document.createElement('span'); m.textContent = digits[k]; m.style.cssText = 'position:absolute;visibility:hidden;white-space:pre';
        el.appendChild(m); dg.style.width = m.getBoundingClientRect().width + 'px'; m.remove();
      });
      var sr = document.createElement('span'); sr.className = 'visually-hidden'; sr.textContent = n; el.appendChild(sr);
      var strips = $$('.pd13-dg > span', wrap);
      var play = function () {
        strips.forEach(function (s, k) {
          var to = -10 * +digits[k];
          var last = k === strips.length - 1, settle = function () { if (last) { el.textContent = n; } };
          if (reduce) { G.set(s, { yPercent: to }); settle(); } else G.fromTo(s, { yPercent: -90 }, { yPercent: to, duration: 1.3 + k * .35, ease: 'power4.out', onComplete: settle });
        });
      };
      G.set(strips, { yPercent: -90 });
      if (window.ScrollTrigger && !reduce) ScrollTrigger.create({ trigger: el, start: 'top 92%', once: true, onEnter: play }); else play();
    }
    var cds = $$('.pd-cd[data-pd-close]');
    var close = cds.length ? +cds[0].getAttribute('data-pd-close') * 1000 : new Date('2026-10-29T23:59:59+11:00').getTime();
    var days = Math.floor((close - Date.now()) / 86400000);
    if (days < 1) return; // the theme's own wording takes over on the last day and after
    cds.forEach(function (cd) { var n = $('.pd-cd__n', cd); if (n && /^\d+$/.test(n.textContent.trim())) odometer(n, +n.textContent.trim()); });

    // the big one in the homepage Diwali band
    var band = $('.aw.band .band__in');
    if (band) {
      var em = $('.em', band);
      var big = document.createElement('p');
      big.className = 'pd13-bigcd';
      big.innerHTML = '<span class="pd13-n"></span> ' + (days === 1 ? 'day' : 'days') + ' to go';
      big.setAttribute('aria-label', days + (days === 1 ? ' day' : ' days') + ' to go');
      (em || $('h2', band)).insertAdjacentElement(em ? 'afterend' : 'beforebegin', big);
      odometer($('.pd13-n', big), days);
      if (window.SplitText && !reduce) {
        var h2 = $('h2', band);
        if (h2) SplitText.create(h2, { type: 'lines', mask: 'lines', autoSplit: true, onSplit: function (self) {
          return G.from(self.lines, { yPercent: 110, duration: .9, stagger: .1, ease: 'expo.out', scrollTrigger: { trigger: h2, start: 'top 88%', once: true } });
        } });
      }
    }
  });

  /* =========================================================================================
     5 · Gold thread through the stores (DrawSVG) — homepage Store Locations
     ========================================================================================= */
  safe('5-stores', function () {
    if (!window.DrawSVGPlugin) return;
    var h = $$('h2').filter(function (x) { return /store locations/i.test(x.textContent); })[0];
    var sec = h && h.closest('.shopify-section'); if (!sec) return;
    var grid = $('.grid', sec); if (!grid) return;
    var items = $$('.js-slider-item', grid), figs = items.map(function (it) { return $('.card__icon figure', it) || $('.card__icon', it); }).filter(Boolean);
    if (figs.length < 2) return;
    grid.classList.add('pd13-stores');
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg'); svg.setAttribute('class', 'pd13-thread'); svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS(NS, 'path'); svg.appendChild(path); grid.insertBefore(svg, grid.firstChild);
    var played = false;
    function build() {
      var g = grid.getBoundingClientRect();
      var pts = figs.map(function (f) { var r = f.getBoundingClientRect(); return [r.left - g.left + r.width / 2, r.top - g.top + r.height / 2, r.width]; });
      var vis = pts.every(function (p) { return p[0] > -1 && p[0] < g.width + 1; });
      svg.style.display = vis ? '' : 'none';
      var d = 'M' + pts[0][0] + ' ' + pts[0][1];
      for (var i = 1; i < pts.length; i++) {
        var p0 = pts[i - 1], p1 = pts[i], mx = (p0[0] + p1[0]) / 2, bend = (i % 2 ? -1 : 1) * Math.min(46, p0[2] * .4);
        d += ' C' + mx + ' ' + (p0[1] + bend) + ' ' + mx + ' ' + (p1[1] + bend) + ' ' + p1[0] + ' ' + p1[1];
      }
      path.setAttribute('d', d);
      if (played) G.set(path, { drawSVG: '100%' });
      return vis;
    }
    if (!build()) return;
    function play() {
      played = true;
      if (reduce) { G.set(path, { drawSVG: '100%' }); return; }
      G.set(path, { drawSVG: '0%' }); G.set(figs, { scale: .86, opacity: .4 });
      var tl = G.timeline();
      figs.forEach(function (f, i) {
        var at = i * .65;
        tl.to(f, { scale: 1, opacity: 1, duration: .7, ease: 'expo.out', clearProps: 'transform,opacity' }, at);
        if (i < figs.length - 1) tl.to(path, { drawSVG: ((i + 1) / (figs.length - 1) * 100) + '%', duration: .65, ease: 'power1.inOut' }, at + .15);
      });
    }
    G.set(path, { drawSVG: '0%' });
    if (window.ScrollTrigger) ScrollTrigger.create({ trigger: grid, start: 'top 75%', once: true, onEnter: play }); else play();
    addEventListener('resize', function () { build(); });
  });

  /* =========================================================================================
     6 · Doors that open wide (21st.dev Hover Expand, rebuilt for the theme) — homepage
     ========================================================================================= */
  safe('6-doors', function () {
    var nav = $('nav.pd-doors'); if (!nav) return;
    var doors = $$('.pd-door', nav); if (!doors.length) return;
    var PH = {
      '/collections/gift-boxes': 'https://cdn.shopify.com/s/files/1/0677/0724/0735/files/9687-Pure_Desi0856.jpg?width=1000',
      '/collections/create-your-own-gift-box': 'https://cdn.shopify.com/s/files/1/0677/0724/0735/files/8680-PureDesi072.jpg?width=1000',
      '/collections/diwali': 'https://cdn.shopify.com/s/files/1/0677/0724/0735/files/9687-Pure_Desi0871.jpg?width=1000'
    };
    nav.classList.add('pd13-doors');
    doors.forEach(function (d) {
      var src = PH[(d.getAttribute('href') || '').split('?')[0]]; if (!src) return;
      var ph = document.createElement('span'); ph.className = 'pd13-door-ph'; ph.setAttribute('aria-hidden', 'true');
      ph.style.backgroundImage = 'url("' + src + '")';
      d.insertBefore(ph, d.firstChild);
    });
    if (!finePointer) return;
    var open = function (d) { doors.forEach(function (x) { x.classList.toggle('pd13-open', x === d); }); };
    doors.forEach(function (d) { d.addEventListener('mouseenter', function () { open(d); }); d.addEventListener('focus', function () { open(d); }); });
    nav.addEventListener('mouseleave', function () { open(null); });
  });

  /* =========================================================================================
     7 · Close look lens (21st.dev Lens) — product photos, mouse only (phones keep the full-screen viewer)
     ========================================================================================= */
  safe('7-lens', function () {
    if (!isProduct || !finePointer) return;
    var ZOOM = 2.4;
    $$('.product-gallery-item').forEach(function (item) {
      var fig = $('figure.lazy-image', item) || $('figure', item), zoom = $('product-image-zoom[data-image]', item);
      if (!fig || !zoom) return;
      var hi = zoom.getAttribute('data-image'); hi = hi + (hi.indexOf('?') > -1 ? '&' : '?') + 'width=1800';
      var lens = document.createElement('div'); lens.className = 'pd13-lens'; lens.setAttribute('aria-hidden', 'true');
      lens.style.backgroundImage = 'url("' + hi + '")';
      // the lens lives in the gallery item (never restyle the photo frame itself: the theme positions it)
      if (getComputedStyle(item).position === 'static') item.style.position = 'relative';
      item.appendChild(lens); fig.classList.add('pd13-lensable');
      fig.addEventListener('mousemove', function (e) {
        if (e.target.closest('button, a, .pd-r2ob__card, [role=dialog]')) { lens.classList.remove('on'); return; }
        var r = fig.getBoundingClientRect(), ir = item.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top, w = lens.offsetWidth;
        lens.style.left = (x + r.left - ir.left - w / 2) + 'px'; lens.style.top = (y + r.top - ir.top - w / 2) + 'px';
        lens.style.backgroundSize = (r.width * ZOOM) + 'px ' + (r.height * ZOOM) + 'px';
        lens.style.backgroundPosition = (-(x * ZOOM - w / 2)) + 'px ' + (-(y * ZOOM - w / 2)) + 'px';
        lens.classList.add('on');
      });
      fig.addEventListener('mouseleave', function () { lens.classList.remove('on'); });
    });
  });

  /* =========================================================================================
     9 · What's inside slides up from the bottom (shadcn Drawer) — product pages on phones
     ========================================================================================= */
  safe('9-sheet', function () {
    if (!isProduct || !matchMedia('(max-width: 767px)').matches) return;
    var wi = $('details.pd-wi-inline'); if (!wi || !$('.pd-wi-inline__list', wi) || !window.Draggable) return;
    var title = (($('.pd-wi-inline__title', wi) || {}).textContent || "What's inside").trim();
    var weight = (($('.pd-wi-inline__weight', wi) || {}).textContent || '').trim();
    var n = $$('.pd-wi-inline__list > li', wi).length;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'pd13-wi-btn'; btn.setAttribute('aria-haspopup', 'dialog');
    btn.innerHTML = '<span><b>' + title + '</b><br><small>' + n + ' sweet' + (n === 1 ? '' : 's') + (weight ? ' · ' + weight : '') + '</small></span><span aria-hidden="true">↑</span>';
    wi.parentNode.insertBefore(btn, wi);
    var veil = document.createElement('div'); veil.className = 'pd13-veil';
    var sh = document.createElement('div'); sh.className = 'pd13-sheet'; sh.setAttribute('role', 'dialog'); sh.setAttribute('aria-modal', 'true'); sh.setAttribute('aria-label', title);
    sh.innerHTML = '<div class="pd13-grab"><i></i></div><div class="pd13-sheet__b"><p class="pd13-sheet__t">' + title + '</p>' + (weight ? '<span class="pd13-sheet__w">' + weight + '</span>' : '') + '</div>';
    var body = $('.pd13-sheet__b', sh);
    // the original list moves into the sheet (no copy, so one source of truth) and back if the sheet is ever removed
    $$('.pd-wi-inline__list, .pd-wi-inline__key', wi).forEach(function (el) { body.appendChild(el); });
    wi.hidden = true; wi.classList.add('pd13-hide'); // the theme styles details.pd-wi-inline with its own display, so [hidden] alone is not enough
    document.body.appendChild(veil); document.body.appendChild(sh);
    var H = function () { return sh.offsetHeight; }, snaps = function () { return [0, H() * .42, H()]; };
    G.set(sh, { yPercent: 0, y: H() });
    function openS(to) {
      sh.classList.add('on'); veil.classList.add('on'); document.documentElement.classList.add('pd13-lock');
      G.to(sh, { y: snaps()[to], duration: reduce ? 0 : .5, ease: 'expo.out' });
    }
    function shut() {
      veil.classList.remove('on'); document.documentElement.classList.remove('pd13-lock');
      G.to(sh, { y: H(), duration: reduce ? 0 : .35, ease: 'power3.in', onComplete: function () { sh.classList.remove('on'); btn.focus(); } });
    }
    btn.addEventListener('click', function () { openS(1); });
    veil.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sh.classList.contains('on')) shut(); });
    Draggable.create(sh, { type: 'y', trigger: $('.pd13-grab', sh), inertia: !!window.InertiaPlugin, edgeResistance: .85,
      bounds: { minY: 0, maxY: 4000 },
      snap: { y: function (v) { return snaps().reduce(function (a, b) { return Math.abs(b - v) < Math.abs(a - v) ? b : a; }); } },
      onRelease: function () { if (!window.InertiaPlugin) { var s = snaps(), t = s.reduce(function (a, b) { return Math.abs(b - this.y) < Math.abs(a - this.y) ? b : a; }.bind(this)); G.to(sh, { y: t, duration: .3 }); if (t === s[2]) shut(); } },
      onThrowComplete: function () { if (this.y >= H() - 2) shut(); } });
  });

  /* =========================================================================================
     10 · Sweet names that explain themselves (shadcn Hover Card) — "What's inside" lines on cards
     ========================================================================================= */
  safe('10-cards', function () {
    var lines = $$('.pd-card-contents'); if (!lines.length) return;
    var keys = Object.keys(SWEETS).sort(function (a, b) { return b.length - a.length; });
    var norm = function (s) { return s.toLowerCase().replace(/barfi/g, 'burfi').replace(/laddoo|laddu|ladu/g, 'ladoo'); };
    var re = new RegExp('\\b(' + keys.map(function (k) { return k.replace(/burfi/g, 'b[au]rfi').replace(/ladoo/g, 'lad+[ou]+'); }).join('|') + ')\\b', 'gi');
    lines.forEach(function (p) {
      // only plain text nodes are wrapped, so the Peek inside button is untouched
      Array.prototype.slice.call(p.childNodes).forEach(function (node) {
        if (node.nodeType !== 3 || !re.test(node.nodeValue)) { re.lastIndex = 0; return; }
        re.lastIndex = 0;
        var frag = document.createDocumentFragment(), txt = node.nodeValue, last = 0, m;
        while ((m = re.exec(txt))) {
          var k = norm(m[1]); if (!SWEETS[k]) continue;
          frag.appendChild(document.createTextNode(txt.slice(last, m.index)));
          var b = document.createElement('button'); b.type = 'button'; b.className = 'pd13-sw'; b.setAttribute('data-k', k); b.textContent = m[1];
          frag.appendChild(b); last = m.index + m[1].length;
        }
        frag.appendChild(document.createTextNode(txt.slice(last)));
        node.parentNode.replaceChild(frag, node);
      });
    });
    if (!$('.pd13-sw')) return;
    var hc = document.createElement('div'); hc.className = 'pd13-hc'; hc.setAttribute('role', 'tooltip'); hc.id = 'pd13-hc';
    hc.innerHTML = '<img alt="" width="64" height="64" hidden><div><b></b><span></span><small></small></div>';
    document.body.appendChild(hc);
    var img = $('img', hc), hideT;
    img.addEventListener('error', function () { img.hidden = true; });
    function show(btn) {
      clearTimeout(hideT);
      var s = SWEETS[btn.getAttribute('data-k')]; if (!s) return;
      $('b', hc).textContent = s[0]; $('span', hc).textContent = s[1]; $('small', hc).textContent = 'Contains: ' + s[2];
      var src = sweetPhoto(s[3]); img.hidden = !src; if (src) img.src = src;
      var r = btn.getBoundingClientRect(), w = 260;
      var x = Math.max(8, Math.min(r.left + r.width / 2 - w / 2, document.documentElement.clientWidth - w - 8));
      hc.style.left = (x + scrollX) + 'px'; hc.style.top = (r.bottom + scrollY + 8) + 'px';
      hc.classList.add('on'); btn.setAttribute('aria-describedby', 'pd13-hc');
    }
    var hide = function () { hideT = setTimeout(function () { hc.classList.remove('on'); }, 120); };
    document.addEventListener('mouseover', function (e) { var b = e.target.closest && e.target.closest('.pd13-sw'); if (b && finePointer) show(b); });
    document.addEventListener('mouseout', function (e) { var b = e.target.closest && e.target.closest('.pd13-sw'); if (b) hide(); });
    document.addEventListener('focusin', function (e) { var b = e.target.closest && e.target.closest('.pd13-sw'); if (b) show(b); });
    document.addEventListener('focusout', function (e) { if (e.target.closest && e.target.closest('.pd13-sw')) hide(); });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.pd13-sw');
      if (b) { e.preventDefault(); e.stopPropagation(); show(b); return; }
      if (!hc.contains(e.target)) hc.classList.remove('on');
    }, true);
    addEventListener('scroll', function () { if (!finePointer) hc.classList.remove('on'); }, { passive: true });
    hc.addEventListener('mouseenter', function () { clearTimeout(hideT); }); hc.addEventListener('mouseleave', hide);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(runAll, 0); });
  else setTimeout(runAll, 0);
})();
